export default __webpack_public_path__ + "static/media/icon-success.f9fdcf2a.svg";